import React from "react";

const SkeletonLoader = () => (
  <div className="animate-pulse">
    {/* Skeleton for Application Details */}
    <section className="bg-white dark:bg-gray-800 p-6 rounded-lg border dark:border-gray-700 mb-6">
      <div className="h-6 bg-gray-200 rounded-full dark:bg-gray-700 rounded w-1/3 mb-4"></div>
      <div className="space-y-2">
        <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 rounded w-1/2"></div>
        <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 rounded w-1/3"></div>
        <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 rounded w-1/4"></div>
        <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 rounded w-1/2"></div>
      </div>
    </section>

    {/* Skeleton for Tasks */}
    <section className="bg-white dark:bg-gray-800 p-6 rounded-lg border dark:border-gray-700 mb-6">
      <div className="h-6 bg-gray-200 rounded-full dark:bg-gray-700 rounded w-1/3 mb-4"></div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[...Array(4)].map((_, index) => (
          <div
            key={index}
            className="p-4 border rounded-lg dark:border-gray-700 space-y-2"
          >
            <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 rounded w-1/2"></div>
            <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 rounded w-3/4"></div>
            <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 rounded w-1/4"></div>
            <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 rounded w-1/3"></div>
          </div>
        ))}
      </div>
    </section>

    {/* Skeleton for Activity Timeline */}
    <section className="bg-white dark:bg-gray-800 p-6 rounded-lg border dark:border-gray-700">
      <div className="h-6 bg-gray-200 rounded-full dark:bg-gray-700 rounded w-1/3 mb-4"></div>
      <div className="space-y-4">
        {[...Array(3)].map((_, index) => (
          <div key={index} className="flex items-center space-x-4">
            <div className="h-4 w-4 bg-gray-200 rounded-full dark:bg-gray-700 rounded-full"></div>
            <div className="flex-1 h-4 bg-gray-200 rounded-full dark:bg-gray-700 rounded"></div>
          </div>
        ))}
      </div>
    </section>
  </div>
);

export default SkeletonLoader;
